
import api from "../../../../../api/api"

const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
      console.log(str)
    return str.join("&");
}

const getTransactionList = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/inventory/transaction?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getStockList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/inventory/stock").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getBillingStock = (companyId,productId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/inventory/stock/"+productId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const add = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/inventory/add",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const adjustStock = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/inventory/adjust",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const getTransactionListByProductId = (productId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/inventory/transaction/"+productId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const inventoryServices = {
    getTransactionList,
    getStockList,
    getBillingStock,
    add,
    adjustStock,
    getTransactionListByProductId
}
export default inventoryServices;